import { SessionStore } from '~/stores/session'
import { PlanType } from '~/generated/api-clients-generated'
import { SiteStore } from '~/stores/site'
import { defaultSupportNumber, resolveSupportNumber } from '~/utils/supportNumbers'

export class SupportNumbers {
  static async use() {
    const { getSupportNumberCollection, getSupportSmsCollection } = Cms.use()
    const { path } = AppRoute.use()
    const session = SessionStore.use()
    const site = SiteStore.use()
    const { environment } = DevModeHelpers.use()
    const { content: supportNumbers } = await getSupportNumberCollection()
    const { content: smsNumbers } = await getSupportSmsCollection()

    const context = computed(() => ({
      path: path.value,
      planType: session.planType,
      journeyId: site.journey.id,
      environment: environment.value
    }))

    const defaultNumber = defaultSupportNumber(supportNumbers.value, environment.value)
    const smsDefaultNumber = defaultSupportNumber(smsNumbers.value, environment.value)

    // null means a rule hides the number on this page
    const phoneNumber = computed(() => {
      const resolved = resolveSupportNumber(supportNumbers.value, context.value)
      return resolved === undefined ? defaultNumber : resolved
    })

    const smsNumber = computed(() => {
      const resolved = resolveSupportNumber(smsNumbers.value, context.value)
      return resolved === undefined ? smsDefaultNumber : resolved
    })

    const isHidden = computed(() => _isNil(phoneNumber.value))

    return {
      phoneNumber,
      defaultNumber,
      smsNumber,
      smsDefaultNumber,
      isHidden
    }
  }

  static usePdpConfig() {
    const { flag } = FeatureFlags.use()
    const tfnForPdp = computed(() => flag<boolean>('support-tfn-on-pdp').value)

    const { path } = AppRoute.use()
    const session = SessionStore.use()

    const hideSupportNumberForPdp = computed(
      () =>
        session.planType === PlanType.PDP &&
        !tfnForPdp.value &&
        (['/drugs', '/medicaid', '/quotes', '/compare', '/standby'].includes(path.value) ||
          path.value.includes('/details'))
    )

    return {
      hideSupportNumberForPdp
    }
  }
}
